import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { GoogleConsentCookieBanner } from '@uncinc/uncinc-react-kitchen-sink';
import { CoreLink } from '@uncinc/react-drupal-core';
import './style.scss';

const Cookie = () => {
  const { t } = useTranslation();

  return (
    <GoogleConsentCookieBanner
      acceptAllText={t('cookies.accept_all')}
      manualText={t('cookies.configure_manually')}
      onlyNecessaryText={t('cookies.accept_only_necessary')}
      acceptSelectionText={t('cookies.accept_selection')}
      // @ts-expect-error
      title={t('cookies.heading')}
      cookieLevels={[
        {
          value: 'necessary',
          label: t('cookies.cookie_levels.necessary.label'),
          description: t('cookies.cookie_levels.necessary.description'),
          disabled: true,
          // @ts-expect-error
          consentOptions: ['security_storage'],
        },
        {
          value: 'preferences',
          label: t('cookies.cookie_levels.preferences.label'),
          description: t('cookies.cookie_levels.preferences.description'),
          disabled: false,
          // @ts-expect-error
          consentOptions: ['functionality_storage', 'personalization_storage'],
        },
        {
          value: 'statistics',
          label: t('cookies.cookie_levels.statistics.label'),
          description: t('cookies.cookie_levels.statistics.description'),
          disabled: false,
          // @ts-expect-error
          consentOptions: ['analytics_storage'],
        },
        {
          value: 'marketing',
          label: t('cookies.cookie_levels.marketing.label'),
          description: t('cookies.cookie_levels.marketing.description'),
          disabled: false,
          // @ts-expect-error
          consentOptions: ['ad_personalization', 'ad_user_data', 'ad_storage'],
        },
      ]}
      defaultValues={{
        necessary: true,
        preferences: false,
        statistics: false,
        marketing: false,
      }}
    >
      <Trans i18nKey="cookies.description">
        {' '}<CoreLink href="/cookies">{' '}</CoreLink><CoreLink href="/privacy">{' '}</CoreLink>
      </Trans>
    </GoogleConsentCookieBanner>
  );
};

export default Cookie;



